<blaze-panel
  #blazePanel
  [hideFooter]="!dataGenerationPanelVisible"
  [hideClose]="true"
  contentClass="overflow-hidden"
>
  <div icon>
    <button blazeIconButton (click)="showPreviousPage()" data-cy="BlazeTable:closeArrow">
      <mat-icon svgIcon="icon_chevron_left_16" />
    </button>
  </div>

  <div title>
    <input
      [size]="tableNameSize"
      class="table-name font-medium"
      type="text"
      [ngModel]="table.name"
      (blur)="renameTable($event)"
    />
  </div>

  <ng-container actions>
    @if (isNotLinkedTable()) {
      <blaze-table-triggers-button
        [tableId]="table.id"
        [triggers]="table.triggers"
        (configTriggers)="configTriggers()"
      />
    }

    @if (canModify && (isGeneratorEnabled$ | async)) {
      <button
        blazeBarButton="secondary"
        (click)="openDataGenerationPanel()"
        data-cy="BlazeTable:Context:GenerateData"
      >
        <mat-icon svgIcon="icon_blaze_16" />Generate Data
      </button>
    }
    <button
      blazeIconButton
      [disabled]="refreshInProgress()"
      (click)="dataReload()"
      data-cy="BlazeTableDialog:reload"
      blazeTooltip="Refresh Data"
    >
      <mat-icon svgIcon="icon_reload_16" />
    </button>
    <blaze-environment-indicator [projectId]="projectId" />
    <input
      #fileInput
      class="hidden"
      type="file"
      [accept]="'.csv'"
      (change)="fileSelected($event.target)"
    />
    <button
      [blazeBarButton]="!!this.filters()?.children?.length ? 'primary' : 'secondary'"
      (click)="openFilterMenu()"
      data-cy="BlazeTableDialog:filterMenuButton"
    >
      <mat-icon svgIcon="icon_filter_16" /> Filter
    </button>
    <button
      #openMenuButton
      [matMenuTriggerFor]="optionsMenu"
      aria-label="Options"
      blazeIconButton
      data-cy="BlazeTableDialog:optionsMenuButton"
    >
      <mat-icon svgIcon="icon_more_h_16" />
    </button>

    <button blazeIconButton (click)="close(blazePanel)" data-cy="Panel:close">
      <mat-icon svgIcon="icon_close_16" />
    </button>
  </ng-container>

  <mat-menu #optionsMenu="matMenu" xPosition="before" class="bd-menu">
    @if (canModify) {
      <button (click)="importCSV()" mat-menu-item>
        <mat-icon svgIcon="icon_download_16" />
        <span>{{ csvImportLabel }}</span>
      </button>
    }

    <button (click)="exportToCSV()" [disabled]="!table.id" mat-menu-item>
      <mat-icon svgIcon="icon_export_16" />
      <span>Export to CSV</span>
    </button>

    @if (table.id && !table.isChangeTrackingTable && !table.systemTableType) {
      <button (click)="onDuplicateTable()" mat-menu-item>
        <mat-icon svgIcon="icon_copy_to_clipboard_16" />
        <span>Duplicate Table</span>
      </button>
    }

    @if (isCopyDataOptionVisible()) {
      <button
        (click)="onCopyDataFromEnvironment(sourceEnvironment())"
        data-cy="BlazeTableDialog:copyDataFromOtherEnv"
        mat-menu-item
      >
        <mat-icon svgIcon="icon_paste_16" />
        @if (sourceEnvironment() === 'Development') {
          <span>Copy Data from Dev</span>
        } @else if (sourceEnvironment() === 'Production') {
          <span>Copy Data from Prod</span>
        }
      </button>
    }

    @if (isNotLinkedTable()) {
      <button (click)="configTriggers()" data-cy="BlazeTableDialog:configTriggers" mat-menu-item>
        <mat-icon svgIcon="icon_workflow_16" />
        <span>Trigger Workflow</span>
      </button>
    }

    <button
      (click)="openIndexesDialog()"
      data-cy="BlazeTableDialog:openIndexesDialog"
      mat-menu-item
    >
      <mat-icon svgIcon="icon_field_type_extra_col_16" />
      <span>Indexes</span>
    </button>

    @if (
      table.id &&
      !table.isChangeTrackingTable &&
      !table.changeTracking?.datasetId &&
      (changeTrackingEnabled$ | async)
    ) {
      <button (click)="enableTracking()" mat-menu-item>
        <mat-icon svgIcon="icon_tracking_16" />
        <span>Enable Change Tracking</span>
      </button>
    }

    @if (
      table.id &&
      !table.isChangeTrackingTable &&
      table.changeTracking?.datasetId &&
      (changeTrackingEnabled$ | async) &&
      isRootUser
    ) {
      <button (click)="disableTracking()" mat-menu-item>
        <mat-icon svgIcon="icon_tracking_stop_16" />
        <span>Disable Change Tracking</span>
      </button>
    }

    @if (
      table.id &&
      !table.isAuditTable &&
      !table.isChangeTrackingTable &&
      !table.accessLog?.enabled &&
      (changeTrackingEnabled$ | async)
    ) {
      <button (click)="enableAccessLogging()" mat-menu-item>
        <mat-icon svgIcon="icon_access_logging_16" />
        <span>Enable Access Logging</span>
      </button>
    }

    @if (
      table.id &&
      !table.isAuditTable &&
      !table.isChangeTrackingTable &&
      table.accessLog?.enabled &&
      (changeTrackingEnabled$ | async) &&
      isRootUser
    ) {
      <button (click)="disableAccessLogging()" mat-menu-item>
        <mat-icon svgIcon="icon_access_logging_stop_16" />
        <span>Disable Access Logging</span>
      </button>
    }

    @if (table.id && canModify) {
      <button (click)="clearData()" mat-menu-item>
        <mat-icon svgIcon="icon_trash_16" />
        <span>Clear Data</span>
      </button>
    }
  </mat-menu>

  <div content class="dataset-preview">
    <blaze-table
      #blazeTable
      [table$]="table$"
      [parentRef]="elRef"
      [projectId]="projectId"
      (configEmitter)="dataGenerationConfig$.next($event)"
      (refreshDataset)="dataReload()"
    />
  </div>

  @if (dataGenerationPanelVisible) {
    <div footer class="data-generation">
      <blaze-table-data-generation-panel
        [config$]="dataGenerationConfig$"
        (closePanel)="dataGenerationPanelVisible = false"
        (dataReload)="dataReload()"
      />
    </div>
  }
</blaze-panel>
